import styled from 'styled-components'

import { InfoMessage } from '@root/shared/ui-kit'

type TransactionHistoryListProps = {
  onRetry: () => void
  withBackground?: boolean
}

export const TransactionHistoryListError = ({
  onRetry,
  withBackground,
}: TransactionHistoryListProps) => {
  return (
    <Root>
      <ErrorMessage
        variant="dt"
        intent="error"
        onRetry={onRetry}
        withBackground={withBackground}
      />
    </Root>
  )
}
const Root = styled.div`
  margin-top: 6px;
  display: grid;

  place-self: center;

  height: 100%;
  width: 100%;
`

const ErrorMessage = styled(InfoMessage)`
  display: grid;
`
